<script setup lang="ts">
/** 通用弹窗外壳：只负责遮罩、面板、标题与关闭；内容由插槽决定。 */
withDefaults(
  defineProps<{
    modelValue: boolean;
    title: string;
    width?: number;
  }>(),
  { width: 380 },
);

const emit = defineEmits<{ 'update:modelValue': [value: boolean] }>();

function close() {
  emit('update:modelValue', false);
}
</script>

<template>
  <Teleport to="body">
    <div v-if="modelValue" class="ui-modal" @click.self="close">
      <div class="ui-modal__panel" :style="{ width: `${width}px` }">
        <header class="ui-modal__head">
          <h2>{{ title }}</h2>
          <button class="ui-modal__close" type="button" aria-label="关闭" @click="close">×</button>
        </header>

        <div class="ui-modal__body">
          <slot />
        </div>

        <footer class="ui-modal__foot">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.ui-modal {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(16 18 20 / 42%);
}

.ui-modal__panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: calc(100vw - 48px);
  padding: 22px;
  border: 1px solid var(--lg-border);
  border-radius: 16px;
  background: var(--lg-panel);
}

.ui-modal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.ui-modal__head h2 {
  font-size: 18px;
}

.ui-modal__close {
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--lg-text-2);
  font-size: 18px;
  cursor: pointer;
}

.ui-modal__close:hover {
  background: var(--lg-hover);
}

.ui-modal__body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ui-modal__foot {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
